<app-management-header></app-management-header>
<div role="main" class="">
  <router-outlet></router-outlet>
</div>
